export default __webpack_public_path__ + "0483bc782a02235a12d5b57ecd16dab9.svg";